export default {
  sections: {
    address: 'Adresse',
    legal_address: 'Registreret adresse',
    invoice_address: 'Faktureringsadresse',
  },
  form: {
    display_name: {
      label: 'Kaldenavn',
      placeholder: 'Indtast virksomhedens kaldenavn',
    },
    legal_name: {
      label: 'Juridisk navn',
      placeholder: 'Indtast juridisk navn',
      tooltip: 'Registreringsnavn. Vises på udbetalingsrapporter, kontrakt osv.',
    },
    timezone: {
      label: 'Tidszone',
    },
    has_dedicated_invoice_address: {
      label: 'Anden faktureringsinfo',
    },
  },
  buttons: {
    next: 'Næste',
  },
};
